/* mx-buy-box.js · Ella · Edición Maximus (30-sep-2026)
   Vainilla, sin librerías. El formulario nativo de Ella es el motor; esto solo:
   1) escribe el id de la variante en el formulario nativo al instante (nunca se agrega la variante anterior),
   2) avisa al selector nativo para que Ella actualice precio, galería y barra,
   3) cambia el texto y el precio del botón,
   4) muestra la barra fija en celular cuando el botón principal sale de la pantalla. */
(function () {
  'use strict';
  if (window.__mxBuyBox) return;
  window.__mxBuyBox = true;

  var NATIVE = 'variant-selects[data-context^="main"]';

  function init(root) {
    if (!root || root.__mxInit) return;
    root.__mxInit = true;

    var formId = root.getAttribute('data-form');
    var radios = Array.prototype.slice.call(root.querySelectorAll('.mx-pack__radio'));
    var cta = root.querySelector('[data-mx-cta]');
    var label = root.querySelector('[data-mx-label]');
    var price = root.querySelector('[data-mx-price]');
    var live = root.querySelector('[data-mx-live]');
    var sticky = root.querySelector('[data-mx-sticky]');
    var stickyBtn = root.querySelector('[data-mx-cta-sticky]');
    var stickyLabel = root.querySelector('[data-mx-label-sticky]');
    var stickyName = root.querySelector('[data-mx-sticky-name]');
    var stickyPrice = root.querySelector('[data-mx-sticky-price]');
    var busyTimer = 0;

    function form() { return document.getElementById(formId); }

    function writeId(id) {
      var f = form();
      var input = f && f.querySelector('input[name="id"]');
      if (input && String(input.value) !== String(id)) input.value = id;
    }

    function nativeRadio(optId) {
      if (!optId) return null;
      return document.querySelector(NATIVE + ' [data-option-value-id="' + optId + '"]');
    }

    function syncNative(radio) {
      writeId(radio.value);
      var nat = nativeRadio(radio.getAttribute('data-option-value-id'));
      if (nat && !nat.checked) {
        nat.checked = true;
        nat.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function paint(radio, announce) {
      radios.forEach(function (r) {
        var tile = r.closest('.mx-pack');
        if (tile) tile.classList.toggle('is-on', r === radio);
      });
      var ok = radio.getAttribute('data-available') !== 'false';
      var lbl = ok ? radio.getAttribute('data-label') : 'Agotado por ahora';
      var prc = ok ? radio.getAttribute('data-price') : '';
      if (label) label.textContent = lbl;
      if (price) price.textContent = prc;
      if (cta) cta.disabled = !ok;
      if (stickyLabel) stickyLabel.textContent = lbl;
      if (stickyPrice) stickyPrice.textContent = prc;
      if (stickyName) stickyName.textContent = radio.getAttribute('data-name') || '';
      if (stickyBtn) stickyBtn.disabled = !ok;
      if (announce && live) live.textContent = 'Elegiste ' + (radio.getAttribute('data-name') || '') + ', ' + (radio.getAttribute('data-price') || '');
    }

    function selectById(id, announce) {
      var hit = radios.filter(function (r) { return String(r.value) === String(id); })[0];
      if (!hit) return;
      hit.checked = true;
      paint(hit, announce);
    }

    // Elegir un paquete
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        paint(r, true);
        syncNative(r);
      });
    });

    // Antes de enviar: el formulario nativo siempre lleva el paquete que se ve elegido
    function onPress() {
      var checked = radios.filter(function (r) { return r.checked; })[0];
      if (checked) writeId(checked.value);
      [cta, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.setAttribute('aria-busy', 'true');
      });
      window.clearTimeout(busyTimer);
      busyTimer = window.setTimeout(function () {
        [cta, stickyBtn].forEach(function (b) { if (b) b.removeAttribute('aria-busy'); });
      }, 1600);
    }
    [cta, stickyBtn].forEach(function (b) { if (b) b.addEventListener('click', onPress); });

    // Si Ella cambia la variante por otro camino (enlace con ?variant, atrás/adelante)
    document.addEventListener('variant:update', function (e) {
      var v = e && e.detail && e.detail.resource;
      if (v && v.id) selectById(v.id, false);
    });

    // Alinear el formulario nativo con el paquete preseleccionado al cargar
    var first = radios.filter(function (r) { return r.checked; })[0];
    if (first) {
      writeId(first.value);
      var align = function () { syncNative(first); };
      if (document.readyState === 'complete') window.setTimeout(align, 0);
      else window.addEventListener('load', function () { window.setTimeout(align, 60); }, { once: true });
    }

    // Selector nativo fuera del teclado y de los lectores de pantalla (queda oculto a la vista)
    function hideNative() {
      if (root.getAttribute('data-native-picker') === 'true') return;
      var nat = document.querySelector(NATIVE);
      if (nat) { nat.setAttribute('aria-hidden', 'true'); if ('inert' in nat) nat.inert = true; }
    }
    hideNative();
    document.addEventListener('variant:update', function () { window.setTimeout(hideNative, 80); window.setTimeout(hideNative, 650); });

    // Barra fija: aparece siempre que el botón principal no se vea (debajo de la pantalla o ya pasado)
    if (sticky && root.getAttribute('data-sticky') !== 'false' && 'IntersectionObserver' in window && cta) {
      document.body.appendChild(sticky);
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var seen = e.isIntersecting && e.intersectionRatio >= 0.6;
        sticky.hidden = seen;
        document.documentElement.classList.toggle('mx-sticky-on', !seen);
      }, { threshold: [0, 0.6, 1] });
      io.observe(cta);
    }
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-mx-bb]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
